import { useEffect, useState } from "react";
import { Crown, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

const emotionalMessages = [
  (n) => `La tua famiglia sta costruendo la sua memoria digitale.`,
  (n) => n > 0 ? `Hai già salvato ${n} ricordi importanti.` : `Inizia ora: carica il primo documento.`,
  (n) => `La tua AI familiare sta imparando dalle vostre conversazioni.`,
  (n) => `Ogni ricordo conta. Continua a costruire.`,
];

export default function TrialBanner() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [msgIdx, setMsgIdx] = useState(0);

  useEffect(() => {
    api.get("/plan/status").then(({ data }) => setStatus(data)).catch(() => {});
  }, []);

  useEffect(() => {
    const id = setInterval(() => setMsgIdx((i) => (i + 1) % emotionalMessages.length), 6000);
    return () => clearInterval(id);
  }, []);

  if (!status) return null;
  if (status.plan === "standard" || status.plan === "premium" && !status.on_trial) {
    return null; // already paid
  }

  const docs = status.usage?.documents || 0;

  if (status.on_trial) {
    return (
      <div
        onClick={() => navigate("/pricing")}
        data-testid="trial-banner"
        className="cursor-pointer bg-surface border border-amber-warm/30 rounded-2xl p-4 mb-5 flex items-center gap-3 hover:bg-elevated transition-colors"
      >
        <div className="w-10 h-10 rounded-2xl bg-amber-warm grid place-items-center shrink-0">
          <Crown className="w-5 h-5 text-app" strokeWidth={1.6} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-medium text-sm">
            Trial Premium attivo · <span className="text-amber-warm">{status.trial_days_left} {status.trial_days_left === 1 ? "giorno" : "giorni"}</span> rimasti
          </div>
          <div className="text-xs text-tertiary-fg mt-0.5 truncate">{emotionalMessages[msgIdx](docs)}</div>
        </div>
        <div className="text-xs text-brand font-medium hidden sm:block">Vedi piani →</div>
      </div>
    );
  }

  // Free plan
  if (status.plan === "free") {
    return (
      <div
        onClick={() => navigate("/pricing")}
        data-testid="upgrade-banner"
        className="cursor-pointer bg-surface border border-brand/30 rounded-2xl p-4 mb-5 flex items-center gap-3 hover:bg-elevated transition-colors"
      >
        <div className="w-10 h-10 rounded-2xl bg-brand grid place-items-center shrink-0">
          <Sparkles className="w-5 h-5 text-white" strokeWidth={1.6} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-medium text-sm">Sblocca il pieno potenziale</div>
          <div className="text-xs text-tertiary-fg mt-0.5 truncate">
            {docs}/50 documenti usati · {emotionalMessages[msgIdx](docs)}
          </div>
        </div>
        <div className="text-xs text-brand font-medium hidden sm:block">Standard →</div>
      </div>
    );
  }

  return null;
}
